__turbopack_context__.v({
  "mySwiper": "tabSliderStyles-module__Mc5tHG__mySwiper",
  "mySwiper2": "tabSliderStyles-module__Mc5tHG__mySwiper2",
  "tabSliderWrapper": "tabSliderStyles-module__Mc5tHG__tabSliderWrapper",
});
